import { AUTO, Cursors, DRAG, DRAG_END, DRAG_START, TARGET } from './../../constants';
import { canDrag } from './canDrag';
import { Shape } from './../../dom/Shape';
export class ConnectionTool {
    constructor(toolService) {
        this.toolService = toolService;
        this.type = 'ConnectionTool';
    }
    tryActivate() {
        return this.toolService._hoveredConnector;
    }
    start(point, meta, nativeEvent) {
        const toolService = this.toolService, diagram = toolService.diagram, connector = toolService._hoveredConnector, connection = diagram._createConnection({}, connector._c, point);
        if (canDrag(connection) && !diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: TARGET, point, meta, nativeEvent }) && diagram._addConnection(connection)) {
            toolService._connectionManipulation(connection, connector._c.shape, true);
            toolService._removeHover();
            toolService.selectSingle(toolService.activeConnection, meta);
            if (meta.type === 'touchmove') {
                diagram._cachedTouchTarget = connector.visual;
            }
        }
        else {
            connection.source(null);
            toolService.end(point, meta, nativeEvent);
        }
    }
    move(point, meta, nativeEvent) {
        const toolService = this.toolService;
        const connection = toolService.activeConnection;
        // Snap to connector when nearby
        let targetPoint = point;
        const connector = toolService._hoveredConnector;
        if (connector && connector._c !== connection.sourceConnector) {
            // Snap the connection endpoint to the connector position without offset
            // This ensures the visual representation matches the actual connection endpoint
            targetPoint = connector._c.positionWithoutOffset();
        }
        connection.target(targetPoint);
        toolService.diagram.trigger(DRAG, { shapes: [], connections: [connection], connectionHandle: TARGET, point, meta, nativeEvent });
        return true;
    }
    end(point, meta, nativeEvent) {
        const toolService = this.toolService, diagram = toolService.diagram, connection = toolService.activeConnection, hoveredItem = toolService.hoveredItem, connector = toolService._hoveredConnector, cachedTouchTarget = diagram._cachedTouchTarget;
        let target;
        if (!connection) {
            return;
        }
        if (connector && connector._c !== connection.sourceConnector) {
            target = connector._c;
        }
        else if (hoveredItem && hoveredItem instanceof Shape) {
            target = hoveredItem.getConnector(AUTO) || hoveredItem.getConnector(point);
        }
        else {
            target = point;
        }
        connection.target(target);
        if (!diagram.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: TARGET, point, meta, nativeEvent })) {
            connection.updateModel();
            diagram._syncConnectionChanges();
        }
        else {
            diagram.remove(connection, false);
            diagram.undoRedoService.pop();
        }
        toolService._connectionManipulation();
        if (cachedTouchTarget) {
            diagram._connectorsAdorner.visual.remove(cachedTouchTarget);
            diagram._cachedTouchTarget = null;
        }
    }
    getCursor() {
        return Cursors.arrow;
    }
}
